<script>
import { find } from 'lodash-es';
</script>

<script setup>
import { Button } from 'flowbite-vue';
import { OhVueIcon } from "oh-vue-icons";
import { ref } from 'vue';

import { wisService } from "../../services/wis.js";
import { store } from '../../store.js';
import { urlHashToObject } from "../../utils";

import ChevronDivider from "../layouts/ChevronDivider.ce.vue";

const urlParams = urlHashToObject(window.location.href);
let levelOneRegions = ref();
let levelTwoRegions = ref();

const service = wisService(store.locale, store.numericCountryCode);
service.getLevelOneRegions().then(data => {
    levelOneRegions.value = data;


    if (urlParams.regionLevelOne !== undefined) {
        levels.one.set(urlParams.regionLevelOne);
    }
});


const levels = {
    one: {
        set: (regionId) => {
            store.regions.levelOne = find(levelOneRegions.value, { id: regionId });

            service.getLevelTwoRegions(regionId).then(data => {
                levelTwoRegions.value = data;

                if (urlParams.regionLevelTwo !== undefined) {
                    levels.two.set(urlParams.regionLevelTwo);
                }
            });
        },
        clear: () => {
            store.regions.levelOne = null;
            store.regions.levelTwo = null;
        }
    },
    two: {
        set: (regionId) => {
            store.regions.levelTwo = find(levelTwoRegions.value, { id: regionId });
        },
        clear: () => {
            store.regions.levelTwo = null;
        }
    },
};
</script>

<template>
    <h2 class="mb-2">{{ store.translations.region_label }}</h2>

    <div v-if="levelOneRegions" class="inline-flex gap-2 flex-wrap items-center">
        <template v-if="store.regions.levelOne">
            <Button color="default" @click="levels.one.clear()"
                class="bg-wageindicator-orange hover:bg-wageindicator-orange-darken">
                {{ store.regions.levelOne.name }}
                <template #suffix>
                    <OhVueIcon name="hi-x" />
                </template>
            </Button>

            <template v-if="store.regions.levelTwo">
                <OhVueIcon name="hi-chevron-right" class="text-slate-400" />
                <Button color="default" class="bg-wageindicator-orange hover:bg-wageindicator-orange-darken"
                    @click="levels.two.clear()">
                    {{ store.regions.levelTwo.name }}
                    <template #suffix>
                        <OhVueIcon name="hi-x" />
                    </template>
                </Button>
            </template>

        </template>
        <template v-else>
            <Button v-for="(region, index) in levelOneRegions" :key="index" color="default" :outline="true"
                @click="levels.one.set(region.id)" class="hover:bg-wageindicator-orange hover:border-wageindicator-orange">
                {{ region.name }}
            </Button>
        </template>
    </div>

    <div v-if="store.regions.levelOne && levelTwoRegions && !store.regions.levelTwo">
        <ChevronDivider />
        <div class="inline-flex align-left gap-2 flex-wrap">
            <Button v-for="(region, index) in levelTwoRegions" :key="index" color="default" :outline="true"
                @click="levels.two.set(region.id)" class="hover:bg-wageindicator-orange hover:border-wageindicator-orange">
                {{ region.name }}
            </Button>
        </div>
    </div>
</template>

<style scoped>
</style>
